// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoContas_CloneInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planocontas/clone
 *
 * Clones a plano de contas from one fechamento to another.
 */
import { registerContract } from './validate'

export interface PlanoContas_CloneInput {
from_fechamento_id: number
to_fechamento_id: number
}

registerContract('PlanoContas_CloneInput', {
  from_fechamento_id: { type: 'number',  required: true },
  to_fechamento_id:   { type: 'number',  required: true },
})
